module.exports = __webpack_public_path__ + "img/user_img_head.45b6e1bd.jpg";